<template>
  <button :type="type" :class="styleList" @click="$emit('click')">
    <slot></slot>  
  </button>
</template>

<script>
import style from './style.module.scss'

export default {
  name: 'Button',
  components: {
    
  },
  props: {
    type: {
      type: String,
      required: false,
      default: "button"
    },
    size: {
      type: String,
      required: false,
      default: 'lg'
    }
  },
  data() {
    return {
      style: style
    }
  },
  computed: {
    styleList() {
      let styleList = [this.style.button];

      switch (this.size) {
      case 'sm':
        styleList.push(this.style.buttonSm)
        break;
      case 'mid':
        styleList.push(this.style.buttonMid)
        break;
      case 'lg':
        styleList.push(this.style.buttonLg)
        break;
      }

      return styleList
    }
  }
}
</script>